import {useEffect, useState} from 'react';
import {graphql, forecastFetchQuery} from '../../../graphql/forecastRelay';
import type {useMentionUsersQuery$data} from './__generated__/useMentionUsersQuery.graphql';

const PeopleSuggestionsQueryDoc = graphql`
	query useMentionUsersQuery {
		viewer {
			peopleSuggestions {
				id
				name
				email
			}
		}
	}
`;

export interface MentionUser {
	id: string;
	name: string;
	email: string;
}

export function useMentionUsers() {
	const [users, setUsers] = useState<MentionUser[]>([]);

	useEffect(() => {
		let cancelled = false;
		forecastFetchQuery(PeopleSuggestionsQueryDoc, {})
			.then(data => {
				if (cancelled) return;
				const typed = data as useMentionUsersQuery$data | null;
				setUsers((typed?.viewer?.peopleSuggestions ?? []) as MentionUser[]);
			})
			.catch(() => {
				if (cancelled) return;
				setUsers([]);
			});
		return () => {
			cancelled = true;
		};
	}, []);

	return {users};
}
